import React, { PureComponent } from 'react'
import moment from 'moment'
import { URIS } from '../../Uris'
import { ENV } from '../../environment'

import { money, grant, generateUrl } from '../Utils/Service'

class ReceiptDetails extends PureComponent {
  render() {
    const r = this.props.receipt
    return (
      <ul className={'row-item ' + r.color}>
        <li>
          <span>Data</span>
          {moment.unix(r.emission_date).format('ll')}
        </li>
        <li>
          <span>Intestatario</span>
          {r.account_holder_name_surname}
        </li>
        <li>
          <span>Numero ricevuta</span>
          {r.number > 0 ? r.number : r.cumulative}
        </li>
        <li className={'info-amount ' + (r.amount < 0 ? 'red' : 'green')}>
          <span>Importo</span>
          {money(r.amount)}
        </li>
        <li className='info-buttons'>
          {r.subscription && (
            <i className='fas fa-handshake' title='Quota associativa'></i>
          )}
          {!r.subscription && (
            <i className='fas fa-receipt' title='Ricevuta'></i>
          )}
          <a
            href={generateUrl(ENV.production, URIS.pdf, r.id, r.checksum)}
            className='lnk-edits'
            target='_blank'
          >
            <i className='fas fa-file-pdf'></i>
          </a>
          {grant() && (
            <button
              className='lnk-edits'
              onClick={() => this.props.showEdit(r)}
            >
              <i className='fas fa-edit'></i>
            </button>
          )}
          {grant() && (
            <button
              className='lnk-edits'
              onClick={() => this.props.showDelete(r)}
            >
              <i className='fas fa-trash-alt'></i>
            </button>
          )}
        </li>
      </ul>
    )
  }
}

export default ReceiptDetails



// WEBPACK FOOTER //
// ./src/components/Receipts/ReceiptDetails.js